module.exports = __webpack_public_path__ + "static/media/johnBalfour.66ca3987.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/johnBalfour.jpg
// module id = 1680
// module chunks = 1